import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/discovery-block")({
  component: lazyRouteComponent(() => import("./-pages/admin.discovery-block")),
});
